module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-video.svg?h=b02775e42e2a53882db75072887b19e0";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-video.svg
// module id = 2048
// module chunks = 12 15